import { Afiliaciones } from '../models/afiliaciones';
import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Afiliaciones';

@Injectable({
  providedIn: 'root'
})
export class AfiliacionesService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  getHistoryByClase(personalId: number, clase: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByClase/' + personalId + '/' + clase });
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseAfiliaciones: '', 
        descripcion: '',
        errores: ['No Completar']}
    ];

    //claseAfiliaciones se deben validar que existan

    return formato;
  }
}
